export default __webpack_public_path__ + "static/media/lamp.e926913f.png";